import { LinkItem } from '@occc-app/design-system';
import { OfferType } from '@occc-app/offerValidationService/types';
import { CampaignComponentTabs } from '@occc-app/routes/CampaignComponents/components/ConfigurationLayout';
import { getTitleByOfferType } from '@occc-app/offerHelpers/utils';

export const routeCreator = {
  base: () => '/program-management',
};

export const createRouteCreator = (offerType: OfferType) => {
  const routeCreator = {
    base: () => `/program-management/${offerType}`,
    details: (offerId: string) => `/program-management/${offerType}/${offerId}`,
    create: () => `${routeCreator.base()}/create`,
    configure: (offerId: string) => `${routeCreator.base()}/${offerId}/configure`,
    configureWithTab: (
      offerId: string,
      tab: CampaignComponentTabs = CampaignComponentTabs.Configure,
    ) => `${routeCreator.configure(offerId)}/${tab}`,
    update: (offerId: string) => `${routeCreator.base()}/${offerId}/update`,
    updateWithTab: (
      offerId: string,
      tab: CampaignComponentTabs = CampaignComponentTabs.Configure,
    ) => `${routeCreator.update(offerId)}/${tab}`,
  };

  return routeCreator;
};

export const getUpdatePageLinks = ({
  offerId,
  offerName,
  offerType,
}: {
  offerId: string;
  offerName: string;
  offerType: OfferType;
}): LinkItem[] => {
  return [
    {
      to: routeCreator.base(),
      label: 'Program Management',
    },
    {
      to: createRouteCreator(offerType).base(),
      label: `${getTitleByOfferType(offerType)} List`,
    },
    {
      to: createRouteCreator(offerType).details(offerId),
      label: offerName || 'Loading...',
    },
  ];
};

export const getCreatePageLinks = (label: string, offerType: OfferType): LinkItem[] => {
  return [
    {
      to: routeCreator.base(),
      label: 'Program Management',
    },
    {
      to: createRouteCreator(offerType).base(),
      label: `${getTitleByOfferType(offerType)} List`,
    },
    {
      key: label,
      label: label,
    },
  ];
};

export const getDetailsPageLinks = (
  offerId: string,
  offerName: string,
  offerType: OfferType,
): LinkItem[] => {
  return [
    {
      to: routeCreator.base(),
      label: 'Program Management',
    },
    {
      to: createRouteCreator(offerType).base(),
      label: `${getTitleByOfferType(offerType)} List`,
    },
    {
      key: offerName,
      label: offerName || 'Loading...',
    },
  ];
};

export const getListPageLinks = (offerType: OfferType): LinkItem[] => {
  return [
    {
      to: routeCreator.base(),
      label: 'Program Management',
    },
    {
      key: `${getTitleByOfferType(offerType)} List`,
      label: `${getTitleByOfferType(offerType)} List`,
    },
  ];
};
